// this is an autogenerated file from DesignSystem/ImageCard/Content/Content/query-print-image-series.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ImageCard_Content_Content(
  $image_series_id: numeric!
  $layout: vaxiom_patient_image_series_layout_type!
) {
  vaxiom_patient_image_series_print(
    image_series_id: $image_series_id
    layout: $layout
  ) {
    url
  }
}

`